import img01 from '../img/characters/01.jpg';
import img02 from '../img/characters/02.jpg';
import img03 from '../img/characters/03.jpg';
import img04 from '../img/characters/04.jpg';

import img05 from '../img/characters/05.jpg';
import img06 from '../img/characters/06.jpg';
import img07 from '../img/characters/07.jpg';
import img08 from '../img/characters/08.jpg';

import img09 from '../img/characters/09.jpg';
import img10 from '../img/characters/10.jpg';
import img11 from '../img/characters/11.jpg';
import img12 from '../img/characters/12.jpg';

import img13 from '../img/characters/13.jpg';
import img14 from '../img/characters/14.jpg';
import img15 from '../img/characters/15.jpg';
import img16 from '../img/characters/16.jpg';

import grave from '../img/grave.jpg';


export class ImagePicker {

    public static GetImage(pos: number, isDead: boolean) {
        if(isDead) {
            return grave;
        }
        
        const now = new Date();
        const date = new Date(now.getTime() - (1000 * 60 * 60 * 8)); // Reset images at 8 am
        const seed = (date.getFullYear() + date.getMonth() + date.getDay())%16;
        let pos16 = pos < 16 ? pos : 15;
        const num = (pos16 + seed < 16 ? pos16 + seed : pos16+seed - 16);

        switch(num) {
            case 1: return img01;
            case 2: return img02;
            case 3: return img03;
            case 4: return img04;
            
            case 5: return img05;
            case 6: return img06;
            case 7: return img07;
            case 8: return img08;
            
            case 9: return img09;
            case 10: return img10;
            case 11: return img11;
            case 12: return img12;
            
            case 13: return img13;
            case 14: return img14;
            case 15: return img15;
            case 0: default: return img16;
        }
    }
}
